/* OBSIDIAN — global theme behaviour */
(function () {
  'use strict';
  var T = window.opxTheme || {};
  var root = T.root || '/';
  if (root.slice(-1) !== '/') root += '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* money */
  function money(cents) {
    var fmt = T.moneyFormat || '€{{amount_with_comma_separator}}';
    cents = Number(cents) || 0;
    function num(n, d, ts, ds) {
      var p = (n / 100).toFixed(d).split('.');
      var i = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ts);
      return i + (p[1] ? ds + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        default: return num(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* header */
  var header = $('[data-opx-header]');
  function onScrollHeader() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 10); }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  /* ---------- overlays (menu + cart) ---------- */
  var lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('opx-lock');
    var f = el.querySelector('button, a, input');
    setTimeout(function () { if (f) f.focus(); }, 60);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('opx-lock');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-opx-menu-open]');
    if (t) { e.preventDefault(); t.setAttribute('aria-expanded', 'true'); openLayer($('#opx-menu')); return; }
    if (e.target.closest('[data-opx-menu-close]')) { closeLayer($('#opx-menu')); return; }
    var c = e.target.closest('[data-opx-cart-open]');
    if (c) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-opx-cart-close]')) { closeLayer($('#opx-cart')); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLayer($('#opx-menu')); closeLayer($('#opx-cart')); }
  });

  /* cart */
  var Cart = {
    el: null,
    fetch: function () {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    add: function (items) {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      });
    },
    change: function (key, qty) {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    },
    open: function () {
      var self = this;
      openLayer($('#opx-cart'));
      return self.fetch().then(function (c) { self.render(c); });
    },
    render: function (cart) {
      var wrap = $('[data-opx-cart-items]');
      $$('[data-opx-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
      var lbl = $('[data-opx-cart-count-label]'); if (lbl) lbl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      var tot = $('[data-opx-cart-total]'); if (tot) tot.textContent = money(cart.total_price);
      var goal = T.freeShip || 5000;
      var st = $('[data-opx-ship-text]'), sb = $('[data-opx-ship-bar]');
      if (st && sb) {
        var left = goal - cart.total_price;
        sb.style.width = Math.min(100, Math.round(cart.total_price / goal * 100)) + '%';
        st.innerHTML = left > 0 ? 'Nog <b>' + money(left) + '</b> tot gratis verzending' : '<b>Gratis verzending</b> — je bestelling komt er gratis aan';
      }
      var up = $('[data-opx-upsell]');
      if (up) {
        var pid = Number(up.getAttribute('data-product-id'));
        up.hidden = cart.item_count === 0 || cart.items.some(function (i) { return i.product_id === pid; });
      }
      if (!wrap) return;
      if (!cart.item_count) {
        wrap.innerHTML = '<div class="opx-cd__empty"><p>Je winkelwagen is nog leeg.</p><a class="opx-btn" href="' + root + 'collections/all">Bekijk de producten</a></div>';
        var f = $('.opx-cd__foot'); if (f) f.hidden = true;
        return;
      }
      var foot = $('.opx-cd__foot'); if (foot) foot.hidden = false;
      wrap.innerHTML = cart.items.map(function (it) {
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="opx-li__var">' + esc(it.variant_title) + '</div>' : '';
        var disc = (it.discounts || []).map(function (d) { return '<div class="opx-li__disc">' + esc(d.title) + '</div>'; }).join('');
        var price = it.original_line_price !== it.final_line_price ? '<span class="opx-strike">' + money(it.original_line_price) + '</span> ' + money(it.final_line_price) : money(it.final_line_price);
        return '<div class="opx-li" data-key="' + esc(it.key) + '">' +
          '<a class="opx-li__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><a class="opx-li__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + disc +
          '<div class="opx-qty"><button type="button" data-opx-qty="-1" aria-label="Minder"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg></button><span>' + it.quantity + '</span><button type="button" data-opx-qty="1" aria-label="Meer"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button></div></div>' +
          '<div class="opx-li__right"><span class="opx-li__price">' + price + '</span><button type="button" class="opx-li__rm" data-opx-rm>Verwijder</button></div>' +
        '</div>';
      }).join('');
    }
  };
  window.opxCart = Cart;

  document.addEventListener('click', function (e) {
    var q = e.target.closest('.opx-cd [data-opx-qty], .opx-cd [data-opx-rm]');
    if (!q) return;
    var li = q.closest('.opx-li');
    if (!li) return;
    var cur = Number((li.querySelector('.opx-qty span') || {}).textContent || 1);
    var next = q.hasAttribute('data-opx-rm') ? 0 : Math.max(0, cur + Number(q.getAttribute('data-opx-qty')));
    li.classList.add('is-busy');
    Cart.change(li.getAttribute('data-key'), next).then(function (c) { Cart.render(c); });
  });

  /* capture-phase add-to-cart for every quick-add form + product form */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-opx-atc], form.opx-pform')) return;
    if (!window.fetch) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var idEl = form.querySelector('[name="id"]');
    var qEl = form.querySelector('[name="quantity"]');
    var items = [{ id: Number(idEl && idEl.value), quantity: Number((qEl && qEl.value) || 1) }];
    Cart.add(items).then(function () {
      if (btn) btn.removeAttribute('aria-busy');
      Cart.open();
    }).catch(function (err) {
      if (btn) btn.removeAttribute('aria-busy');
      var msg = (err && (err.description || err.message)) || 'Toevoegen mislukt. Probeer het opnieuw.';
      var box = form.querySelector('[data-opx-error]');
      if (box) { box.textContent = msg; box.hidden = false; } else { alert(msg); }
    });
  }, true);

  /* ---------- product page ---------- */
  $$('[data-opx-product]').forEach(function (pdp) {
    var dataEl = pdp.querySelector('[data-opx-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = pdp.querySelector('form.opx-pform');
    var idInput = form && form.querySelector('[name="id"]');
    var btn = form && form.querySelector('[type="submit"]');
    var btnLabel = btn && btn.querySelector('[data-opx-btn-label]');
    var priceEl = pdp.querySelector('[data-opx-price]');
    var compareEl = pdp.querySelector('[data-opx-compare]');
    var saveEl = pdp.querySelector('[data-opx-save]');
    var track = pdp.querySelector('.opx-gal__track');
    var sticky = document.querySelector('[data-opx-sticky-atc]');

    function selected() {
      return $$('.opx-opt', pdp).map(function (fs) {
        var c = fs.querySelector('input:checked');
        var lg = fs.querySelector('[data-opx-opt-value]');
        if (c && lg) lg.textContent = c.value;
        return c ? c.value : null;
      });
    }
    function update() {
      var opts = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      if (!v) {
        if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = 'Niet beschikbaar'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (btn) {
        btn.disabled = !v.available;
        if (btnLabel) btnLabel.textContent = v.available ? 'In winkelwagen — ' + money(v.price) : 'Uitverkocht';
      }
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      if (saveEl) {
        if (v.compare_at_price > v.price) { saveEl.hidden = false; saveEl.textContent = 'Bespaar ' + money(v.compare_at_price - v.price); }
        else saveEl.hidden = true;
      }
      if (v.featured_media && track) {
        var slide = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) goTo(Array.prototype.indexOf.call(track.children, slide));
      }
      if (sticky) {
        var sid = sticky.querySelector('[name="id"]'); if (sid) sid.value = v.id;
        var sp = sticky.querySelector('[data-opx-sticky-price]'); if (sp) sp.textContent = money(v.price);
        var sv = sticky.querySelector('[data-opx-sticky-variant]'); if (sv) sv.textContent = v.title !== 'Default Title' ? v.title : '';
        var sb = sticky.querySelector('[type="submit"]'); if (sb) sb.disabled = !v.available;
      }
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    pdp.addEventListener('change', function (e) { if (e.target.closest('.opx-opt')) update(); });

    /* quantity */
    pdp.addEventListener('click', function (e) {
      var b = e.target.closest('[data-opx-step]');
      if (!b) return;
      var inp = b.parentNode.querySelector('input');
      inp.value = Math.max(1, (Number(inp.value) || 1) + Number(b.getAttribute('data-opx-step')));
    });

    /* gallery */
    var thumbs = $$('.opx-gal__thumbs button', pdp);
    function goTo(i) {
      if (!track || !track.children[i]) return;
      track.scrollTo({ left: track.children[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) { thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); }); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
      }, { passive: true });
      $$('[data-opx-gal]', pdp).forEach(function (b) {
        b.addEventListener('click', function () {
          var i = Math.round(track.scrollLeft / track.clientWidth) + Number(b.getAttribute('data-opx-gal'));
          var n = track.children.length;
          goTo((i + n) % n);
        });
      });
    }

    /* sticky add-to-cart (mobile) */
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(btn);
    }
  });

  /* ---------- product recommendations ---------- */
  $$('[data-opx-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div');
      d.innerHTML = html;
      var inner = d.querySelector('[data-opx-recs]');
      if (inner && inner.innerHTML.trim().length) { el.innerHTML = inner.innerHTML; reveal(el); }
      else { el.closest('.shopify-section') && (el.closest('.shopify-section').style.display = 'none'); }
    });
  });

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-opx-sort]');
    if (!s) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* reveal */
  function reveal(scope) {
    var els = $$('.opx-rv:not(.is-in)', scope);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }
  reveal(document);
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });

  /* ---------- scroll-linked marquee ---------- */
  var marquees = $$('[data-opx-marquee]');
  if (marquees.length && !reduce) {
    var tick = false;
    var run = function () {
      tick = false;
      marquees.forEach(function (m) {
        var r = m.getBoundingClientRect(), vh = window.__opxVH || window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = (vh - r.top) / (vh + r.height);
        var dir = Number(m.getAttribute('data-opx-marquee')) || 1;
        var line = m.querySelector('.opx-mq__line');
        if (line) line.style.transform = 'translate3d(' + (dir * (-p * 30)).toFixed(2) + '%,0,0)';
      });
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* cart count on load */
  if ($('[data-opx-cart-count]')) Cart.fetch().then(function (c) {
    $$('[data-opx-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.hidden = c.item_count === 0; });
  }).catch(function () {});
})();